import { BORDER_STYLE, OUTLINE_STYLE, MAIN_STYLE_GROUPS, PADDING_SIDES, PRESS_EVENTS } from '../shared.js'
export const spinner = {
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                bg_color:     { type: 'color', format: 'hex8' },
                bg_opa:       { type: 'int', min: 0, max: 255, internal: true },
                radius:       { type: 'int', min: 0, max: 999 },
                padding:      { type: 'int', min: 0, exportSpecial: true },
                ...PADDING_SIDES,
                ...BORDER_STYLE,
                ...OUTLINE_STYLE,
                line_width:   { type: 'int', min: 0 },
                line_color:   { type: 'color' },
            },
        },
        indicator: {
            label: 'Spinning Segment',
            exportSuffix: '10',
            order: 1,
            properties: {
                line_width:   { type: 'int', min: 0 },
                line_color:   { type: 'color' },
                line_rounded: { type: 'bool' },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled:   { type: 'bool' },
        // Fully generic attribute (attribute_common_bool, hasp_attribute.cpp:2722-2729) that
        // every sibling schema (arc/slider/bar) already declares — previously absent here.
        hidden:    { type: 'bool' },
        type:      { type: 'int', min: 0, max: 2 },
        direction: { type: 'int', min: 0, max: 1 },
        speed:     { type: 'int', min: 100, step: 100, unit: 'ms' },
        angle:     { type: 'int', min: 0, max: 360, unit: '°', hasp: true },
        animation: { type: 'bool' },
        stretch_mode: {
            type: 'string', internal: true, default: 'keep_ratio',
            options: ['none', 'keep_ratio'],
        },
        // Designer-only value-text overlay (canvas preview convenience, no
        // firmware/LVGL counterpart) — same VALUE_FONT-slot convention as
        // gauge.js/arc.js/linemeter.js's identically-named properties (see
        // gauge.js's comment for the full wire-format semantics).
        value_str:   { type: 'string' },
        value_font:  { type: 'int', min: 8 },
        value_font_resource: { type: 'resource', resourceType: 'font', label: 'Value Font Family', inline: true },
        value_color: { type: 'color' },
        value_ofs_x: { type: 'int', label: 'value offset x' },
        value_ofs_y: { type: 'int', label: 'value offset y' },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 40, min_height: 10,
            enabled: true, hidden: false,
            // angle 60 = LV_SPINNER_DEF_ARC_LENGTH (lv_spinner.c:24,86) — was 45, which didn't
            // match either the real firmware default or HaspSpinner.js's own (also wrong)
            // hardcoded "is this still default" comparison of 90; that widget-code comparison
            // is left as-is here (Phase 4 migrates it onto the standard style-resolver
            // pipeline instead of duplicating the schema default as a literal).
            angle: 60, speed: 1000, animation: true,
            // type 0 = LV_SPINNER_TYPE_SPINNING_ARC (lv_spinner.c:32,87), the real LVGL
            // default — was 2 (CONSTANT_ARC).
            type: 0, direction: 0,
            value_str: '', value_font: 32, value_ofs_x: 0, value_ofs_y: 0,
            value_color: '#ffffff', value_font_resource: '',
        },
        styles: {
            // line_width 25 (both parts) matches the real theme value via the shared
            // arc_indic style (lv_theme_hasp.c:625, applied to LV_SPINNER_PART_INDIC by
            // theme_apply's LV_THEME_SPINNER case) — was 15 on main, entirely unset on
            // indicator. HaspSpinner.js's own export/"is this still default" check compares
            // against a separate hardcoded DEFAULT_LINE_WIDTH = 20 (HaspSpinner.js:19), now
            // inconsistent with this corrected schema default; that's expected for this
            // schema-only pass — migrating HaspSpinner.js off that bespoke constant onto the
            // standard StyleResolver/computeEffectiveStyleEntries pipeline (as arc/slider/bar
            // already use) is Phase 4, not this one.
            main:      { line_width: 25, padding: 8 },
            indicator: { line_width: 25 },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy', 'keep_ratio'],
    runtimeCapabilities: ['has_action'],

    events: PRESS_EVENTS,
    bindings: { properties: {}, actions: { hass_services: [] }, events: {} },
}
